import { render } from "./CadastrarCategoria.vue?vue&type=template&id=5226ae58&scoped=true"
import script from "./CadastrarCategoria.vue?vue&type=script&lang=js"
export * from "./CadastrarCategoria.vue?vue&type=script&lang=js"

import "./CadastrarCategoria.vue?vue&type=style&index=0&id=5226ae58&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5226ae58"]])

export default __exports__